module.exports = __webpack_public_path__ + "img/007.4a896608.jpg";